import * as yup from 'yup';
import { constantesRequerimentos } from '@utils';

const { SEM_JORNAL, SEM_CORRESPONDENCIA } = constantesRequerimentos;

export const RecebimentoCorrespondenciaSchema = yup.object({
  opcaoRecebimento: yup
    .string()
    .oneOf(
      [SEM_JORNAL, SEM_CORRESPONDENCIA],
      'Atenção, Selecione a Opção de recebimento'
    )
    .required('Atenção, Selecione a Opção de recebimento'),
});

export const RecebimentoCorrespondenciaInitialValues = {
  opcaoRecebimento: '',
};
